export default {
    about: 'a-propos',
    home: 'accueil',
    message_desk: 'Discutez avec un représentant local de l\'expérience client via SMS'
}
